import { Stack, Typography, Grid, Card, Collapse, IconButton, SxProps, Theme, Box } from '@mui/material';
import { PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import Iconify from '../Iconify';

export interface ExpandableCardProps {
  openCollapseExternal?: boolean;
  title?: string;
  sxProp?: SxProps<Theme>;
  children?: ReactNode | undefined;
  inlineChildren?: ReactNode | undefined;
  isCollapsible?: boolean;
  compactContentGap?: boolean;
}

export default function ExpandableCard({
  openCollapseExternal = false,
  title,
  sxProp,
  children,
  inlineChildren,
  isCollapsible = true,
  compactContentGap = false,
}: ExpandableCardProps) {
  const [openCollapse, setOpenCollapse] = useState(false);

  useEffect(() => {
    setOpenCollapse(openCollapseExternal);
  }, [openCollapseExternal]);

  const stackSx = isCollapsible
    ? compactContentGap
      ? { m: 2, mb: 0.5 }
      : { m: 2 }
    : { m: 0 };

  return (
    <Card sx={sxProp}>
      <Stack sx={stackSx}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography sx={{ ml: 1 }}>
            {title}
            {isCollapsible && (
              <IconButton onClick={() => setOpenCollapse(!openCollapse)}>
                <Iconify
                  icon={openCollapse ? 'eva:arrow-ios-upward-fill' : 'eva:arrow-ios-downward-fill'}
                />
              </IconButton>
            )}
          </Typography>
          {inlineChildren}
        </Box>
      </Stack>
      <Collapse in={openCollapse}>{children ? children : null}</Collapse>
    </Card>
  );
}
